module.exports = __webpack_public_path__ + "img/12.92cc3545.jpg";